import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const classNames = (...inputs) => twMerge(clsx(inputs));
